import { BaseIcon } from './BaseIcon';

export const VisibilityOff = (): JSX.Element => <BaseIcon code={'visibility-off'} />;
